import PropTypes from 'prop-types'
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'

// Internal components
import Button from '../Button/Button'

// Context
import { ModalContext } from '../../context/ModalContext'
import { UserContext } from '../../context/UserContext'

const CreateTrigger = (props) => {
  const { routeLabel, routePath } = props

  // Context
  const modalContext = useContext(ModalContext)
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const updateModalRoute = () => {
    modalContext.setModalId(false)
    modalContext.setModalRoute(routePath)
  }

  return (
    <div className="CreateTrigger">
      <div className="CreateTrigger-link" onClick={() => updateModalRoute()}>
        {routePath && <Button icon={{ id: 'icon-add' }} modifiers={['Button--addCircular']} />}
        {routeLabel && <div className="CreateTrigger-label">{t(routeLabel)}</div>}
      </div>
    </div>
  )
}

CreateTrigger.propTypes = {
  routePath: PropTypes.string.isRequired,
  routeLabel: PropTypes.string
}

export default CreateTrigger
